export default {
  common: {
    loading: '加载中...',
    error: '错误',
    save: '保存',
    cancel: '取消',
    close: '关闭',
    confirm: '确认',
    delete: '删除',
    edit: '编辑',
    noData: '暂无数据',
    justNow: '刚刚',
    retry: '重试',
    reject: '拒绝',
    ago: '前',
    increase: '增加',
    decrease: '减少',
  },
  auth: {
    login: '登录',
    email: '邮箱',
    emailRequired: '请输入邮箱地址。',
    emailInvalid: '请输入有效的邮箱地址。',
    forgotPassword: '忘记密码？',
    sendCode: '发送验证码',
    sendingCode: '发送中...',
    codeSent: '已为 {email} 请求验证码，请查收邮箱；未收到时可稍后重试。',
    enterCode: '输入验证码',
    codeRequired: '请输入 6 位验证码。',
    codeInvalid: '验证码必须是 6 位数字。',
    verifyAndSignIn: '验证并登录',
    verifying: '验证中...',
    changeEmail: '更换邮箱',
    resendCode: '重新发送验证码',
    otpResendCountdown: '{seconds}秒后重新发送',
    consentRequired: '请同意条款以继续。',
    consentAgreement: '我同意{terms}和{privacy}',
    terms: '服务条款',
    privacy: '隐私政策',
    displayNameRequired: '请输入显示名称。',
    featureOtel: 'OTel 可观测',
    featureConfig: '配置与密钥',
    featureDeploy: '一键部署',
    brandTitle: 'ServerlessInsight',
    brandTagline: '多云无服务器基础设施——可视化、可管理。',
  },
  errors: {
    notFoundTitle: '页面未找到',
    notFoundDescription: '您查找的页面不存在或已被移动。',
    somethingWentWrong: '出了点问题',
  },
  legal: {
    terms: { title: '服务条款' },
    privacy: { title: '隐私政策' },
    refund: { title: '退款政策' },
    termsSummary:
      '本协议约定账号、使用规范、预付费余额与出账（充值预存、月度出账、欠费冲抵、余额永久有效）、无自动续订、MoR 支付与退款、责任限制等。',
    privacySummary:
      '我们收集邮箱、账单流水与您声明的基础设施内容；存储于中国内地阿里云（支付经记名卖方处理）；secret 配置项 AES-256-GCM 加密；资金流水按财税要求保留。',
    refundSummary:
      '可退金额 = 未消耗且未开票的余额（减去在途退款），欠费优先结清；审核 1–3 个工作日后原路退回；账单错误无条件更正。',
    updated: '最后更新：2026 年 10 月',
    readFull: '阅读完整文档',
  },
  footer: {
    terms: '服务条款',
    privacy: '隐私政策',
    refundPolicy: '退款政策',
  },
  onboarding: {
    title: '欢迎使用 ServerlessInsight',
    subtitle: '首先，创建一个应用来开始使用。',
    orgNamePlaceholder: '组织名称（可选）',
    displayNamePlaceholder: '您的姓名',
    create: '创建应用',
    creating: '创建中...',
    skip: '稍后再说',
  },
  profile: {
    title: '编辑资料',
    displayName: '显示名称',
    displayNamePlaceholder: '您的姓名',
    email: '邮箱',
    save: '保存',
    saving: '保存中...',
    saveSuccess: '资料已更新。',
  },
  nav: {
    resources: '资源',
    deployments: '部署',
    config: '配置与密钥',
    observability: '可观测',
    administration: '管理控制台',
    logout: '退出登录',
    organization: '组织',
    createOrg: '新建组织',
    editProfile: '编辑资料',
    darkMode: '深色模式',
    lightMode: '浅色模式',
  },
  orgCreate: {
    title: '新建组织',
    nameLabel: '组织名称',
    namePlaceholder: '输入组织名称',
    nameRequired: '请输入组织名称',
    submit: '创建',
    creating: '创建中…',
  },
  topbar: {
    selectApp: '选择应用...',
  },
  appSelector: {
    noApps: '暂无应用',
  },
  stageSelector: {
    allStages: '所有环境',
  },
  deployments: {
    title: '部署',
    subtitle: '所有服务和环境的部署历史',
    detail: '部署详情',
    backToDeployments: '返回部署列表',
    retry: '重试',
    status: {
      pending: '等待中',
      planning: '规划中',
      awaiting_approval: '待审批',
      awaitingApproval: '待审批',
      deploying: '部署中',
      completed: '已完成',
      failed: '失败',
      rolled_back: '已回滚',
      rolledBack: '已回滚',
    },
    source: {
      cli: 'CLI',
      console: '控制台',
      ci: 'CI/CD',
    },
    tab: {
      events: '事件',
      changes: '变更',
      outputs: '输出',
      stateJson: '状态 JSON',
    },
    error: {
      title: '部署失败',
      unknown: '部署失败，但未记录到错误信息。',
    },
    timeline: {
      title: '部署时间线',
      noEvents: '暂无部署事件记录。',
      duration: '耗时',
      phase: {
        start: '开始',
        planning: '规划',
        apply: '执行',
        fail: '失败',
      },
      status: {
        done: '完成',
        failed: '失败',
        inProgress: '进行中',
        diagnostic: '诊断',
        planned: '待执行',
      },
    },
    table: {
      id: 'ID',
      service: '服务',
      version: '版本',
      source: '来源',
      triggeredBy: '触发者',
      commit: '提交',
      time: '时间',
    },
    filter: {
      allStatuses: '所有状态',
      allSources: '所有来源',
      allServices: '所有服务',
      search: '搜索部署...',
    },
    emptyTitle: '暂无部署',
    emptyDescription: '部署第一个服务后，部署历史将显示在这里。',
    rollback: '回滚',
    rollbackTitle: '回滚部署',
    rollbackDescription:
      '确定要回滚 {version} 吗？该版本部署于 {time} 前。这将把基础设施状态恢复到上一个版本。',
    rollbackConfirm: '确认回滚',
    rollbackCancel: '取消',
    changes: {
      title: '变更内容',
      noItems: '该部署没有变更记录。',
      noPropertyChanges: '无属性级变更。',
      actionCreate: '创建',
      actionUpdate: '变更',
      actionDelete: '删除',
      before: '变更前',
      after: '变更后',
    },
    outputs: {
      noData: '该部署没有输出数据。',
      noResources: '未部署任何资源。',
      section: {
        functions: '函数',
        apiGateway: 'API 网关',
        storage: '存储',
        databases: '数据库',
        dns: 'DNS 记录',
        other: '其他资源',
      },
    },
    stateJson: {
      noData: '暂无状态数据。',
    },
    notFound: '部署未找到',
    notFoundDescription: '您要找的部署不存在或已被移除。',
  },
  resources: {
    backToResources: '返回资源列表',
    retry: '重试',
    quickStats: {
      totalServices: '总服务数',
      totalResources: '总资源数',
      recentDeployments: '部署（24h）',
    },
    serviceDetail: {
      resources: '资源',
      stages: '环境',
      created: '创建于',
    },
    resourceTable: {
      type: '类型',
      name: '名称',
      service: '服务',
      region: '区域',
      properties: '属性',
      search: '搜索资源...',
      noResults: '没有匹配的资源。',
      emptyTitle: '暂无资源',
      emptyDescription: '该应用尚未部署任何资源。',
    },
    resourceDetail: {
      title: '资源详情',
      resourceInfo: '资源信息',
      stage: '环境',
      cloudId: '云资源 ID',
      properties: '属性',
      noProperties: '暂无属性',
      linkedResources: '关联资源',
      noLinked: '暂无关联资源',
      deploymentHistory: '部署历史',
      noHistory: '暂无部署历史',
      version: '版本',
      source: '来源',
      resourceCount: '资源数',
      date: '日期',
      close: '关闭',
      sourceDeploy: '部署',
      sourceRollback: '回滚',
      sourceDrift: '配置漂移',
      sourceImport: '导入',
      resourceIdFallback: '(资源 ID: {id})',
      reveal: '显示值',
      mask: '隐藏值',
    },
    status: {
      healthy: '健康',
      degraded: '降级',
      error: '异常',
      ready: '就绪',
      running: '运行中',
      active: '活跃',
      updating: '更新中',
      available: '可用',
      unavailable: '不可用',
      unknown: '未知',
      creating: '创建中',
      deleted: '已删除',
      paused: '已暂停',
      suspended: '已挂起',
    },
    servicesTable: {
      search: '搜索服务...',
      serviceName: '服务名称',
      provider: '云厂商',
      stages: '环境',
      resources: '资源数',
      lastDeployed: '最近部署',
      noResults: '没有匹配的服务。',
      emptyTitle: '暂无服务',
      emptyDescription: '该应用尚未创建任何服务。',
    },
    resourceType: {
      function: '函数',
      'api-gateway': 'API 网关',
      gateway: '网关',
      'gateway-service': '网关服务',
      api: 'API',
      trigger: '触发器',
      role: '角色',
      'security-group': '安全组',
      storage: '存储',
      bucket: '存储桶',
      database: '数据库',
      search: '检索',
      table: '数据表',
      queue: '队列',
      topic: '主题',
      log: '日志',
      cdn: 'CDN',
      cname: 'CNAME',
      'dns-verification': 'DNS 验证',
      deployment: '部署',
      upstream: '上游',
      route: '路由',
      nas: 'NAS',
      domain: '域名',
      unknown: '未知',
    },
  },
  admin: {
    title: '管理控制台',
    subtitle: '组织信息、成员、API 密钥、账户账单与审计日志。',
    accountScope: '账户级 · 覆盖所有组织',
    tab: {
      billing: '账单',
      organization: '组织信息',
      members: '成员',
      apiKeys: 'API 密钥',
      auditLogs: '审计日志',
    },
    billingSupport: {
      siteCurrency: '站点默认',
      title: 'Support 详情与账户核账',
      scopeNote: '仅平台管理员可用，跨账号查询会记录审计。资金操作前请核实支付凭证。',
      search: '查询',
      refresh: '刷新',
      filters: '筛选',
      reconcile: '前往核账',
      all: '全部',
      details: '详情',
      userFilter: '用户邮箱或 ID',
      userId: '用户 ID（UUID）',
      ticketId: '工单 ID',
      orderId: '订单号 / 渠道交易号 / 流水 ID',
      currency: '币种',
      pagination: '分页',
      pageInfo: '第 {page} / {pages} 页 · 共 {total} 条',
      previous: '上一页',
      next: '下一页',
      loading: '加载中…',
      resolution: '处理结果',
      assignee: '处理人',
      updatedAt: '更新时间',
      resolvedAt: '处理时间',
      completedAt: '完成时间',
      noAccount: '该用户尚未创建计费账户。',
      balanceCents: '已结算余额',
      reservedCents: '预留金额',
      availableBalanceCents: '可用余额',
      arrearsCents: '欠费',
      entryType: '流水类型',
      evidence: '流水凭证',
      entryTypes: {
        topup: '充值',
        deduction: '扣费',
        repay: '偿还欠费',
        refund: '退款 / 冻结',
        adjustment: '余额调整',
        annual: '包年套餐',
      },
      ledgerStatuses: {
        pending: '待确认',
        success: '已成功',
        failed: '失败 / 已取消',
      },
    },
    billingOps: {
      topupsTitle: '充值订单',
      topupsNote:
        'Webhook 丢失兜底：仅在 PSP 侧核实款项已到账后人工确认入账（与 webhook 走同一账本事务与幂等键）。',
      ticketsTitle: '工单审核',
      ticketsNote: '审核退款与开票申请。',
      createdAt: '时间',
      user: '用户',
      provider: '通道',
      category: '类别',
      categoryOptions: {
        invoice: '开票',
        refund: '退款',
      },
      summary: '摘要',
      status: '状态',
      statusOptions: {
        pending: '待处理',
        approved: '已审核',
        completed: '已完成',
        rejected: '已拒绝',
        failed: '失败',
      },
      showAll: '查看全部',
      showActionable: '只看待处理',
      expiresAt: '过期时间',
      expiredBadge: '已过期',
      amount: '金额',
      confirmTopup: '人工确认入账',
      approveIssue: '通过并开具',
      approveRefund: '通过审核',
      completeRefund: '完成入账',
      rejectTitle: '拒绝原因',
      rejectPlaceholder: '请填写拒绝原因',
    },
    orgSettings: {
      workspacesTitle: 'Apps',
      workspacesNote: '由 serverlessinsight.yml 部署创建 · 只读',
      noWorkspaces: '暂无 Apps — 通过 CLI 部署创建。',
      wsName: '名称',
      wsServices: '服务数',
      wsCreated: '创建时间',
      wsUpdated: '最后修改',
      title: '组织设置',
      name: '组织名称',
      slug: '标识',
      created: '创建时间',
      createdBy: '创建者',
      you: '你',
      rename: '重命名',
      renameSuccess: '组织已重命名。',
      renameError: '重命名组织失败。',
      nameRequired: '组织名称不能为空。',
      delete: '删除组织',
      deleteWarning: '此操作不可撤销。该组织的所有应用、服务和数据将被永久删除。',
      deleteConfirm: '删除',
      deleteSuccess: '组织已删除。',
      deleteError: '删除组织失败。',
      noOrg: '未选择组织。',
    },
    members: {
      email: '邮箱',
      name: '姓名',
      role: '角色',
      scope: '范围',
      app: '应用',
      created: '创建时间',
      emptyTitle: '暂无成员',
      emptyDescription: '没有可显示的团队成员。',
      fetchError: '加载成员失败',
      retry: '重试',
      unnamed: '(未命名)',
      global: '全局',
      deleteConfirmTitle: '移除成员',
      deleteConfirmMessage: '确定要移除 {email} 吗？',
      deleteConfirm: '移除',
    },
    apiKeys: {
      name: '名称',
      status: '状态',
      noOrg: '请先选择或创建一个组织。',
      key: '密钥',
      scopes: '权限范围',
      source: '来源',
      created: '创建时间',
      actions: '操作',
      create: '新建 API 密钥',
      createTitle: '创建 API 密钥',
      keyName: '密钥名称',
      keyNamePlaceholder: '例如：deploy-cli',
      createError: '创建 API 密钥失败。',
      fullKeyLabel: '您的 API 密钥',
      fullKeyWarning: '请立即复制此密钥。出于安全考虑，它将不再显示。',
      copy: '复制',
      copied: '已复制！',
      copyError: '复制到剪贴板失败。',
      revokeConfirmTitle: '吊销 API 密钥',
      revokeConfirmMessage: '确定要吊销 "{name}" 吗？此操作无法撤销。',
      revokeConfirm: '吊销',
      revokeError: '吊销 API 密钥失败。',
      statusActive: '有效',
      statusDisabled: '已禁用',
      statusRevoked: '已吊销',
      sourceLogin: '登录',
      sourceManual: '手动',
      emptyTitle: '暂无 API 密钥',
      emptyDescription: '创建 API 密钥以配合 ServerlessInsight CLI 使用。',
      fetchError: '加载 API 密钥失败',
      retry: '重试',
    },
    auditLogs: {
      action: '操作',
      category: '类别',
      severity: '严重级别',
      actor: '操作者',
      resource: '资源',
      created: '创建时间',
      filterAction: '按操作筛选...',
      allCategories: '所有类别',
      allSeverities: '所有级别',
      fromDate: '开始日期',
      toDate: '结束日期',
      clearFilters: '清除筛选',
      emptyTitle: '暂无审计日志',
      emptyDescription: '没有匹配的审计事件。',
      fetchError: '加载审计日志失败',
      retry: '重试',
      categoryOptions: {
        auth: '认证',
        deploy: '部署',
        config: '配置与密钥',
        member: '成员',
        security: '安全',
        account: '账户',
      },
      severityOptions: {
        info: '信息',
        warning: '警告',
        critical: '严重',
      },
    },
  },
  observability: {
    title: '可观测',
    subtitle: '最近的基础设施事件时间线。',
    refresh: '刷新',
    emptyTitle: '暂无审计事件',
    emptyDescription: '基础设施事件发生后将显示在这里。',
    fetchError: '加载事件失败',
    retry: '重试',
    table: {
      action: '操作',
      category: '类别',
      severity: '级别',
      actor: '操作者',
      resource: '资源',
      time: '时间',
      search: '搜索事件...',
      noResults: '没有匹配的事件。',
    },
    detail: {
      title: '事件详情',
      eventInfo: '事件信息',
      details: '详情',
      related: '关联',
      viewDeployment: '查看部署详情',
      noDetails: '无详情',
      metadata: '元数据',
      ipAddress: 'IP 地址',
      userAgent: '用户代理',
      action: '操作',
      category: '类别',
      severity: '级别',
      actor: '操作者',
      resource: '资源',
      time: '时间',
      close: '关闭',
    },
  },
  config: {
    title: '配置管理',
    subtitle: '管理应用的配置集。',
    emptyTitle: '暂无配置集',
    emptyDescription: '创建第一个配置集来管理应用配置。',
    noResults: '没有匹配的配置集。',
    newButton: '新建配置集',
    scope: {
      all: '全部',
      global: '全局',
      app: '应用',
      service: '服务',
      stage: '环境',
    },
    table: {
      name: '名称',
      scope: '范围',
      items: '配置项',
      tags: '标签',
      updated: '更新',
      actions: '操作',
    },
    modal: {
      titleNew: '新建配置集',
      name: '名称',
      description: '描述',
      scope: '范围',
      items: '配置项',
      addItem: '添加配置项',
      key: '键',
      itemDescription: '说明',
      changeSummary: '变更说明',
      saveVersion: '保存为新版本',
      create: '创建配置集',
      cancel: '取消',
      deleteWarning: '此操作将永久删除配置集及其所有版本。',
      delete: '删除',
      noItems: '请至少添加一个配置项。',
      editHint: '编辑已有配置集，修改将保存为新版本。',
    },
    itemType: {
      string: '字符串',
      number: '数字',
      boolean: '布尔',
      json: 'JSON',
      yaml: 'YAML',
      text: '文本',
      secret: '密钥',
    },
    version: {
      title: '版本历史',
      noVersions: '暂无版本',
      current: '当前版本',
      promote: '升级为最新',
      promoting: '升级中...',
      by: '由',
    },
    strategy: {
      title: '部署策略',
      saved: '策略已更新',
      mode: '策略',
      allAtOnce: '全量发布',
      linear: '线性发布',
      canary: '金丝雀发布',
      autoRollback: '自动回滚',
      enabled: '启用',
      disabled: '禁用',
      threshold: '回滚阈值',
      thresholdUnit: '% 错误率',
      interval: '间隔',
      intervalUnit: '秒',
      observationWindow: '观察窗口',
      observationUnit: '分钟',
    },
    healthStatus: {
      healthy: '健康',
      degraded: '降级',
      failed: '失败',
      rollingBack: '回滚中',
    },
    promoteComingSoon: '升级功能即将推出',
    meta: {
      saved: '配置集已更新',
    },
    detail: {
      backToConfig: '返回配置列表',
      items: '配置项',
      saveDescription: '描述此版本的变更内容。',
      versionLabel: '版本',
      saveVersion: '保存为新版本',
      editMeta: '编辑配置集',
      selectService: '选择服务...',
      selectStage: '选择环境...',
    },
    deleteConfirm: {
      title: '删除配置集',
      description: '此操作不可撤销。该配置集的所有版本都将被永久删除。请输入配置集名称以确认。',
      typeToConfirm: '输入配置集名称以确认：',
      cancel: '取消',
      delete: '删除',
    },
  },
  cliAuthorize: {
    title: 'CLI 授权',
    redirecting: '正在返回 CLI...',
    retry: '重试',
    goToOnboarding: '前往引导页',
    closeWindowHint: 'CLI 确认登录后即可关闭此窗口。',
    selectOrg: '选择组织',
    selectKey: '选择 API 密钥',
    createNewKey: '创建新密钥',
    keyListEmpty: '该组织暂无现有密钥。',
    keyListLoading: '正在加载密钥...',
    confirm: '授权',
    keySourceLogin: '登录',
    keySourceManual: '手动',
    rotateHint: '将会颁发新的密钥，旧密钥将立即失效。',
    errors: {
      invalidRedirect: 'redirect_uri 无效或缺失。此授权链接格式不正确。',
      noOrg: '授权 CLI 前需要先创建组织。请先创建一个。',
      createFailed: '创建 API 密钥失败，请重试。',
    },
  },
  billing: {
    annual: {
      activeUntil: '年付有效期至 {date}',
      pitch:
        'Team 年付 {price}（按 10 个月计费，省 17%）——自下个账期起覆盖 12 个月基础月费，超额仍按 {overage}/AMR 从余额扣。',
      buy: '年付订阅（10 个月价）',
      autoRenew: '到期前 30 天内自动从余额续费',
      cancelRenewal: '取消已续费的周期（退回余额）',
      cancelled: '已取消续费周期，{amount} 已退回余额',
      purchased: '年付已开通 — 有效期至 {until}，费用已从余额扣除',
    },
    usage: {
      amr: 'AMR 用量',
      members: '成员',
      workspaces: '组织',
      budgetAlert: '本月账单已达预算上限的 {percent}%。',
      comparePlans: '查看版本对比',
    },
    budget: {
      capLabel: '预算上限（{currency} / 月，留空 = 不限制）',
      alertNote:
        '每日检查当月预估支出，达到阈值时邮件提醒计费账户所有者；同账期每个阈值最多提醒一次。',
      capPlaceholder: '如 50',
      thresholdLabel: '告警阈值',
      save: '保存',
      saved: '预算已保存。',
    },
    balance: {
      title: '余额',
      available: '可用余额',
      arrears: '欠费金额',
      arrearsBadge: '欠费中',
      arrearsLine: '欠费 {amount}',
      arrearsHint:
        '账户存在欠费：新资源创建已被阻断（存量资源不受影响）。充值后将自动优先冲抵欠费。',
      lowBadge: '余额偏低',
      lowHint: '按近 30 天日均消耗估算，余额即将不足 — 建议尽快充值。',
      daysRemaining: '按近 30 天日均消耗估算，≈ 还能撑 {days} 天',
      noConsumptionYet: '暂无消耗记录 — 首次出账后显示消耗估算。',
      topup: '充值',
      topupNow: '去充值',
      refund: '退款',
      advanced: '高级',
      invoicing: '发票与实名',
    },
    topup: {
      title: '账户充值',
      creating: '正在创建支付…',
      customLabel: '自定义金额（最低 {min}）',
      customPlaceholder: '如 88',
      customTooSmall: '单笔充值不得低于 {min}。',
      customTooLarge: '单笔充值不得超过 {max}。',
      unavailable: '当前站点未开通在线充值 — 请联系商务或使用线下汇款。',
      createdTitle: '充值单已创建',
      createdBody: '完成支付后，余额将自动到账（通常为秒级 — 无需人工确认）。',
      resumeCheckout: '重新打开支付页面',
      provider: {
        manual: '当前站点未开通在线充值（manual 模式）。',
        alipay: '支付方式：支付宝（电脑网站支付）— 支付完成后余额自动到账。',
        creem: '支付方式：Creem（银行卡 / 国际支付）— 支付完成后余额自动到账。',
        waffo: '支付方式：Waffo Checkout — 支付完成后余额自动到账。',
        stripe: '支付方式：Stripe（银行卡 / 国际支付）— 支付完成后余额自动到账。',
      },
      pending: {
        title: '待支付充值单',
        banner: '{count} 笔待支付 — 完成支付或取消',
        resume: '继续支付',
        cancel: '取消',
        cancelled: '已取消该充值单。',
        expiredBadge: '已过期',
        expiredHint: '如已付款，请联系支持核实入账。',
      },
    },
    refund: {
      title: '余额退款',
      policyNote: '仅未消费且未开票的余额可退（原路退回）。提交后由平台管理员审核处理。',
      refundable: '可退金额',
      all: '全部',
      amountLabel: '退款金额',
      overLimit: '退款金额不能超过可退金额。',
      minHint: '单笔退款不得低于 {min}。',
      belowMin: '单笔退款不得低于 {min}。',
      refundBelowMin: '可退金额低于最低退款金额 {min}，如需退款请联系支持。',
      reasonLabel: '退款原因',
      reasonPlaceholder: '如：误充 / 重复充值',
      submit: '提交退款申请',
      submittedNote: '退款申请已提交 — 平台管理员会尽快审核并原路退回。',
      loadError: '退款信息加载失败 — 请刷新重试。',
      historyTitle: '最近退款申请',
      status: {
        pending: '待审核',
        approved: '已审核（退款处理中）',
        rejected: '已拒绝',
        completed: '已完成',
        failed: '失败',
      },
    },
    invoiceCenter: {
      title: '发票管理',
      policyNote: '按充值开票 · 抬头须与实名认证一致',
      realnameTitle: '实名认证（开票主体）',
      realnameType: '主体类型',
      typeCompany: '企业',
      typePersonal: '个人',
      companyName: '企业名称',
      personalName: '姓名',
      taxId: '税号',
      contactEmail: '接收邮箱',
      saveProfile: '保存实名信息',
      profileSaved: '实名信息已保存。',
      realnameNote: '开票抬头必须与实名认证主体完全一致；平台管理员将在开票审核时复核实名信息。',
      invoicableTitle: '可开票金额（{amount}）',
      amountLabel: '本次开票金额',
      amountHint: '不超过可开票金额 {max}。',
      amountInvalid: '开票金额必须在 0 与 {max} 之间。',
      loadError: '开票信息加载失败 — 请刷新重试。',
      noInvoicable: '暂无可开票的充值记录。',
      needRealnameFirst: '请先完成实名认证 — 开票抬头必须与实名主体一致。',
      appliedNote: '开票申请已提交 — 审核通过后电子发票将发送至接收邮箱。',
      apply: '申请开票（{amount}）',
      requestDate: '申请日期',
      requestTitle: '抬头',
      requestStatus: '状态',
      requestAmount: '金额',
      status: {
        pending: '待审核',
        approved: '已审核',
        completed: '已开具',
        rejected: '已拒绝',
        failed: '开票失败',
        issued: '已开具',
      },
    },
    summaryUnavailable: '账单信息加载失败 — 请重试。',
    blocked: {
      title: '操作已被计费策略拦截',
      modalTitle: '已达到计费限制',
      manage: '管理账单',
      reason: {
        INSUFFICIENT_BALANCE:
          '账户余额不足或存在欠费 — 充值后即可继续创建新资源，存量资源不受影响。',
        QUOTA_EXCEEDED: '已超出版本配额 — 请升级版本后继续。',
        ACCOUNT_SUSPENDED: '该计费账户已被封停 — 请联系支持。',
      },
    },
    invoices: {
      noLineItems: '本期无费用。',
      kind: {
        base: '基础月费',
        amr_overage: 'AMR 超额',
      },
    },
    upgradeBanner: {
      text: '您的月账单持续走高 — Team {price}/月含 {amr} AMR、{members} 名成员与自动部署。',
      cta: '查看版本',
    },
    checkout: {
      title: '升级到 {plan}',
      current: '当前版本',
      currentUsage: '当前用量',
      after: '升级后',
      price: '费用',
      prorationNote: '首月按天折算 — 只为新版本的实际天数付费。',
      effectNote: '余额充足时立即生效；费用将在本月账单出账时从余额扣除。',
      paymentTitle: '余额支付',
      paymentBody:
        '预付费余额模式（issue #38）：版本变更不再单独收款 — 余额须覆盖折算后本月应扣，出账时从余额统一扣除。',
      submit: '余额校验并升级',
      submitting: '正在升级…',
      submittedTitle: '升级已生效',
      submittedBody: '余额校验通过，新版本已立即生效。本月账单将按天折算后从余额扣除。',
    },
    resourceTypes: {
      ALIYUN_FC3_FUNCTION: '函数计算 FC3（阿里云）',
      SCF_FUNCTION: '云函数 SCF（腾讯云）',
      VOLCENGINE_VEFAAS_FUNCTION: '函数服务 VeFaaS（火山引擎）',
      ALIYUN_OSS_BUCKET: '对象存储 OSS（阿里云）',
      COS_BUCKET: '对象存储 COS（腾讯云）',
      VOLCENGINE_TOS_BUCKET: '对象存储 TOS（火山引擎）',
      ALIYUN_RDS_SERVERLESS: '云数据库 RDS Serverless（阿里云）',
      TDSQL_C_SERVERLESS: '云数据库 TDSQL-C Serverless（腾讯云）',
      ALIYUN_ES_SERVERLESS: '检索分析 ES Serverless（阿里云）',
      ALIYUN_APIGW_GROUP: 'API 网关分组（阿里云）',
      ALIYUN_CDN_DISTRIBUTION: 'CDN 加速域名（bucket.cdn 边缘产物）',
      ALIYUN_NAS_FILE_SYSTEM: '文件存储 NAS（function.nas 边缘产物）',
      ALIYUN_NAS_MOUNT_TARGET: 'NAS 挂载点（自动生成）',
      ALIYUN_NAS_ACCESS_GROUP: 'NAS 访问组（自动生成）',
      ALIYUN_SLS_PROJECT: '日志服务 SLS Project（阿里云）',
      ALIYUN_SLS_LOGSTORE: '日志服务 SLS Logstore（阿里云）',
      ALIYUN_SLS_INDEX: '日志服务 SLS 索引（阿里云）',
      TENCENT_CLS_LOGSET: '日志服务 CLS 日志集（腾讯云）',
      TENCENT_CLS_TOPIC: '日志服务 CLS 日志主题（腾讯云）',
      ALIYUN_APIGW_API: 'API 网关 API（自动生成）',
      ALIYUN_APIGW_DEPLOYMENT: 'API 网关部署（自动生成）',
      ALIYUN_APIGW_LOG_CONFIG: 'API 网关日志配置（自动生成）',
      ALIYUN_TABLESTORE_TABLE: '表格存储 Tablestore（阿里云）',
    },
    subscription: {
      yourPlan: '当前套餐',
      unlockTitle: '升级到 {plan} 将解锁',
      unlockPitch: '包含当前套餐的全部能力，外加：',
      upgradeTo: '升级到 {plan}',
      upgradeToWithPrice: '升级到 {plan} · {price}/月',
      overageCheaper: '超额单价更低：{price}/AMR（现在 {current}/AMR）',
      topTierTitle: '已在最高档',
      topTierNote: '当前已是最高档套餐 — 如需更高额度请联系商务。',
      usageSection: '用量',
      budgetSection: '预算',
      cloudView: '跨云视图',
      overageTitle: '超出部分的计费方式',
    },
    usageDetails: {
      noCap: '未设置预算上限',
      burnHint: '已达月度预算的 {percent}%。',
      limitsTitle: '订阅与预算',
      plan: {
        developer: 'Developer',
        team: 'Team',
        enterprise: 'Enterprise',
      },
      footprint: '实时 AMR 足迹',
      footprintHint:
        '组织 → 服务 → 阶段，可下钻到资源类型 × 实例数 × 权重 — 每个数字都可追溯到账单。',
      managed: '在管',
      instances: '实例',
      paygTooltip: '参考价：超出免费额度后按当前版本单价 {price}/AMR 计费',
      workspaceFolding: '组织超含入：{extra} 个 × +1 AMR = {amr} AMR',
    },
    trend: {
      title: '用量趋势',
      hint: '最近 6 个账期 — 应扣金额与已从余额扣款金额（纯 CSS 柱图）。',
      billed: '应扣',
      charged: '已扣',
      arrears: '欠费 {amount}',
      arrearsHint: '余额不足的部分已挂为欠费，充值后自动冲抵。',
      empty: '暂无账单记录 — 首次月度出账后显示。',
    },
  },
  pricing: {
    title: '定价',
    nav: {
      login: '登录',
      register: '免费开始',
      backToConsole: '返回控制台',
    },
    hero: {
      title: '简单定价，随您扩展',
      subtitle:
        '万物一个单位：AMR。您在 yml 中声明的每个实体实例 — 函数、网关、桶、库、表 — 均为 1 AMR。Developer 免费含 10 AMR 起步，超出后升级 Team。',
      monthlyOnly: '月付（年付稍后推出）',
    },
    common: {
      month: '月',
      custom: '联系销售',
    },
    cards: {
      popular: '最受欢迎',
      yourPlan: '当前版本',
      amrQuota: '含 {n} AMR',
      amrQuotaCustom: 'AMR 额度按合同约定',
      teamValue: '含 {included} AMR — 按 Developer 按量价折算价值 {worth}，仅需 {price}',
      autoDeploy: '自动部署',
      billedFromBalance: '余额扣费',
    },
    cta: {
      startFree: '免费开始',
      upgrade: '升级到 Team',
      currentPlan: '当前版本',
      contactSales: '联系销售',
      downgrade: '降级到 Developer',
    },
    feat: {
      overage: '超出后 {price} / AMR',
      overageCustom: '超额单价按合同约定',
      members: '{n} 名成员（硬配额）',
      membersUnlimited: '成员不限',
      workspaces: '含 {n} 个组织',
      workspacesUnlimited: '组织不限',
      workspaceOverage: '超额组织 +{amr} AMR / 个',
    },
    spec: {
      views: {
        readonly: '只读透传',
        full: '统一跨云搜索',
      },
      alertOnly: '超额告警',
      supportOptions: {
        developer: '社区',
        team: '工单 · 1 个工作日',
        enterprise: '专属 TAM · 7×24',
      },
    },
    pricing: {
      title: '资源价格',
      subtitle: '按实例计费 — 每个声明实体实例每月消耗其权重的 AMR。',
      resource: '资源',
      amrCol: 'AMR / 实例 · 月',
      free: '免费',
      groupLabel: '权重 {weight}',
      zeroGroupLabel: '0 AMR — 以下永远免费',
      workspaceRow: '组织（超含入数）',
      workspaceWeightNote: '每个 / 月',
      amrPriceNote: '超出额度后 1 AMR 单价：Developer {dev} · Team {team}；免费额度内不计费。',
      enterpriseNote: 'Enterprise 单价按合同约定（≤ 目录价）。',
    },
    breakdown: {
      title: '计费说明',
      coversTitle: '1 个 AMR 可以是什么',
      coversIntro: '1 个 AMR 可兑换以下任意一项（按月计）。',
      fnName: '函数实例',
      fnDetail: 'FC3 · SCF · VeFaaS',
      apigwName: 'API 网关分组',
      apigwDetail: '每个分组',
      bucketName: '对象存储桶',
      bucketDetail: 'OSS · COS · TOS',
      dbName: 'Serverless 数据库',
      dbDetail: 'RDS · TDSQL-C · ES',
      tableName: '数据表',
      tableDetail: 'Tablestore',
      wsName: '超额工作区',
      wsDetail: '超出含入数的部分',
      perInstance: '/ 实例 · 月',
      perWorkspace: '/ 个 · 月',
      zeroName: '自动生成的附属资源',
      zeroDetail: '日志 · 角色 · API 部署 · 域绑定 · 挂载点',
      zeroBadge: '0 AMR · 永远免费',
      exampleTitle: '算一笔账',
      exampleNote: 'Developer 免费额度 {free} AMR/月内不计费；超出后按版本单价计费。',
      rulesTitle: '计费规则',
      rule1: '阶段存活 ≥ 14 天且当月有成功部署 → 计入 AMR',
      rule2: 'personal-* 阶段永久免费（每组织最多 2 个）',
      rule3: '每月 1 日 00:00 UTC 结算；免费额度内不产生费用',
      rule4: 'Developer 预算：80% 告警、100% 阻断新部署（现有资源不受影响）',
      rule5: '月中升级按天折算；降级次月 1 日生效',
    },
    faq: {
      title: '常见问题',
      q1: 'Developer 版真的免费吗？',
      a1: '是的 — 免费额度内（10 AMR、1 成员、1 工作区）永久免费，无需预付。超出后可充值余额按量扣费，或设置预算硬上限控制成本。',
      q2: '什么时候升级 Team 更划算？',
      a2: 'Team {teamPrice}/月含 {amr} AMR — 按 Developer 按量价（{payg}/AMR）折算价值 {worth}。当月账单接近 {alert}（Team 的 80%）时控制台会自动提示升级；超出含入 {amr} AMR 后每 AMR 仅 {teamOverage}，是 Developer 的一半。',
      q3: '如何付款？',
      a3: '在控制台发起充值，通过 Checkout 页用国际信用卡或常见钱包完成支付——余额实时到账、永久有效；套餐月费与超额用量自动从余额扣减，余额永不为负。',
      q4: '免费额度用完又不充值会怎样？',
      a4: '不会有任何破坏。现有资源继续运行，但当 AMR 用量（含超出含入数的工作区）超过免费额度后，新部署将被暂停；充值余额后自动恢复。成员是所有版本的硬配额：Developer 第 2 名成员需要升级。',
      q5: '可以降级回 Developer 吗？',
      a5: '可以 — 在 Billing 页自助操作。降级于次月 1 日生效；届时若用量超出 Developer 免费额度，新部署将被暂停（充值余额即可恢复）。',
      q6: '价格含税吗？',
      a6: '展示价格为未税牌价。税务处理因地区与支付通道而异 — 国际支付由我们的记录商户（Creem）处理 VAT / 销售税。',
      q7: '为什么 1 个函数 = 1 AMR，而不是按资源总数计价？',
      a7: '因为您思考的粒度是交付物，而不是管道。yml 中声明的每个实体 — 一个函数、一个桶、一张表 — 就是一个可管理单元，权重 1 AMR；其下自动生成的资源（日志存储、执行角色、API 部署、域绑定、挂载点）权重一律为 0。账单因此可预期，也绝不惩罚您把基础设施接线接得规范。',
    },
  },
}
